module.exports = __webpack_public_path__ + "img/team-leo.689c1bb2.jpg";